var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 27,
    viewBox: "0 0 47 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 26.1111,
    rx: 4.7,
    fill: "#032167"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6037 18.4463V18.1243H36.5198L36.4227 18.3455L36.3261 18.1243H36.2416V18.4463H36.3013V18.2035L36.392 18.413H36.4538L36.5446 18.2029V18.4463H36.6037ZM36.0711 18.4463V18.1792H36.1788V18.1248H35.9043V18.1792H36.012V18.4463H36.0711Z",
    fill: "#F79410"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0602 19.8316H19.7959V6.77637H27.0602V19.8316Z",
    fill: "#FF5F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2618 13.3026C20.2618 10.6543 21.5017 8.29524 23.4327 6.77498C22.0206 5.66329 20.2386 4.99976 18.3018 4.99976C13.7167 4.99976 10 8.71701 10 13.3026C10 17.8882 13.7167 21.6055 18.3018 21.6055C20.2386 21.6055 22.0206 20.9419 23.4327 19.8302C21.5017 18.31 20.2618 15.9509 20.2618 13.3026Z",
    fill: "#EB001B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.857 13.3026C36.857 17.8882 33.1403 21.6055 28.5552 21.6055C26.6185 21.6055 24.8364 20.9419 23.4238 19.8302C25.3553 18.31 26.5953 15.9509 26.5953 13.3026C26.5953 10.6543 25.3553 8.29524 23.4238 6.77498C24.8364 5.66329 26.6185 4.99976 28.5552 4.99976C33.1403 4.99976 36.857 8.71701 36.857 13.3026Z",
    fill: "#F79E1B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.f5131fab7ddb34728449844fb271c34b.svg";
export { ForwardRef as ReactComponent };